import './SliderSocios.css'

function SliderSocios() {
  return (
<div className="logos">
  <h2 className='Subtitle-h2 edit-title-h2-secC'>NUESTROS CLIENTES</h2>
<div className="logos-slide">
 <img className="img-size-client-esp" src="img/Clientes-img/Cliente4.svg" alt=""/>
    <img src="img/Clientes-img/Cliente1.png" alt="" />
   
    <img src="img/Clientes-img/Cliente2.png"alt="" />
    <img className="img-size-client-esp"src="img/Clientes-img/Cliente3.png" alt=""/>
      <img className="img-size-client-esp" src="img/Clientes-img/Cliente4.svg" alt=""/>
    <img src="img/Clientes-img/Cliente1.png"alt="" />
  
    <img src="img/Clientes-img/Cliente2.png" alt=""/>
    <img className="img-size-client-esp" src="img/Clientes-img/Cliente3.png" alt=""  />
      <img className="img-size-client-esp" src="img/Clientes-img/Cliente4.svg" alt=""/>
    <img src="img/Clientes-img/Cliente1.png" alt=""/>
  
    <img src="img/Clientes-img/Cliente2.png" alt=""/>
    <img className="img-size-client-esp" src="img/Clientes-img/Cliente3.png" alt=""  />
        <img className="img-size-client-esp" src="img/Clientes-img/Cliente4.svg" alt=""/>
    <img src="img/Clientes-img/Cliente1.png" alt=""/>

    <img src="img/Clientes-img/Cliente2.png" alt=""/>
    <img className="img-size-client-esp" src="img/Clientes-img/Cliente3.png" alt="" />

  
    
  </div>

</div>

  );
}

export default SliderSocios;
